import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MetaTagService } from 'src/app/shared/services/MetaTagService/meta-tag.service';
import { VideoService } from '../details-page/components/video-service/services/video/video.service';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.css'],
})
export class CourseComponent implements OnInit, OnDestroy {
  data!: any;  
  lesson!: any;

  language!: string;
  routeSub!: Subscription;
  constructor(private route: ActivatedRoute, private router: Router, private videoService: VideoService, private metaTagService: MetaTagService) {}

  ngOnInit(): void {
    this.language = this.route.snapshot.url[0].path
    this.routeSub = this.route.params.subscribe(params => {
      if (params['lang']) {
        this.language = params['lang'];   
        this.getResolverData();         
      }
    }); 
  }

  playVideo(lesson: any) {
    this.videoService.getVideo(lesson.path).subscribe((response: any) => {
      const body = 'data:' + response.headers['Content-Type'][0] + ';base64,' + response.body;
      this.lesson.video = body;
    });
  }

  openLesson(lesson: any) {
    let parts = this.route.snapshot.url.map(segment => segment.path);
    const videoName = lesson.path.split('\\').pop();
    if (parts.length === 3) {
      parts.push(videoName);
    } else if (parts.length === 4) {
      parts[3] = videoName;
    }

    const newUrl = parts.join('/');
    this.router.navigate([newUrl]);
  }

  extractVideoName(video: string) {
    return video.split('\\')[video.split('\\').length - 1];
  }

  getResolverData(){    
    const resolverData = this.route.snapshot.data['course'];            
    if (resolverData) {
      this.data = resolverData.content;
      if (this.route.snapshot.params['video']) {
        this.lesson = this.data.videoLesson;
        this.playVideo(this.lesson);        
      }
      
      this.metaTagService.updateMetaTags(resolverData.metadata.meta);
    } else {
      console.error("Resolver data is undefined");
    }    
  }

  ngOnDestroy(): void {   
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
